<template>
  <el-drawer size="1200px" :visible="selfVisible" :title="title" @update:visible="visibleChange" class="topic-detail-drawer" :append-to-body="true">
    <div class="info-content">
      <div class="base-msg">
        <div class="title">{{ $t('dms_topic_detail_drawer.ji_ben_xin_xi') }}</div>
        <ul class="msg-list">
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.Topiclei_bie') }}</div>
              <div class="val">
                {{ getDicName('iot_topic_class', data.topicClass) || '-' }}
              </div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.Topiclei_xing') }}</div>
              <div class="val">
                {{ getDicName('iot_topic_type', data.topicType) || '-' }}
              </div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.Topicming_cheng') }}</div>
              <div class="val">
                {{ data.topicName || '-' }}
              </div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.Topicbian_ma') }}</div>
              <div class="val">{{ data.topicCode || '-' }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.xie_yi_bian_ma') }}</div>
              <div class="val">{{ data.tcpTopicCode || '-' }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.suo_shu_ye_wu') }}</div>
              <div class="val">{{ getDicValue('iot_topic_biz_code', data.topicBizCode) || '-' }}</div>
            </div>
          </li>
          <li class="msg-item" v-if="data.topicUrl">
            <div class="msg-item-content">
              <div class="key">Topic URL</div>
              <div class="val">{{ data.topicUrl || '-' }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.yun_xu_xia_fa_ji_qi') }}</div>
              <div class="val">{{ getDicValue('iot_topic_control_mode', data.controlMode) || '-' }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.shang_chuan_lei_xing') }}</div>
              <div class="val">{{ getDicValue('iot_topic_upload_type', data.uploadType) || '-' }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.scjgm') }}</div>
              <div class="val">{{ data.uploadInterval === undefined ? '-' : data.uploadInterval }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.ccsct') }}</div>
              <div class="val">{{ data.storageDuration === undefined ? '-' : data.storageDuration }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.chao_shi_ce_lve') }}</div>
              <div class="val">{{ getDicValue('iot_tsl_timeout_strategy', data.timeoutStrategy) || '-' }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.csddm') }}</div>
              <div class="val">{{ data.timeoutWait === undefined ? '-' : data.timeoutWait }}</div>
            </div>
          </li>
          <li class="msg-item">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.cscscs') }}</div>
              <div class="val">{{ data.timeoutRetryCount === undefined ? '-' : data.timeoutRetryCount }}</div>
            </div>
          </li>
          <li class="msg-item" v-if="data.commandMode">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.ming_ling_mo_shi') }}</div>
              <div class="val">{{ getDicValue('topic_command_mode', data.commandMode) || '-' }}</div>
            </div>
          </li>
          <li class="msg-item" v-if="data.commandStatusType">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.mlztlx') }}</div>
              <div class="val">{{ getDicValue('command_status_type', data.commandStatusType) || '-' }}</div>
            </div>
          </li>
          <li class="msg-item" v-if="data.commandStatusDicGroup">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.mlztzdx') }}</div>
              <div class="val">{{ data.commandStatusDicGroup || '-' }}</div>
            </div>
          </li>

          <li class="msg-item" v-if="data.topicDesc">
            <div class="msg-item-content">
              <div class="key">{{ $t('dms_topic_detail_drawer.Topicmiao_shu') }}</div>
            </div>
            <div class="desc" v-show="data.topicDesc">
              {{ data.topicDesc }}
            </div>
          </li>
        </ul>
      </div>
      <div class="table-content">
        <div class="tab-content">
          <!-- Topic数据存储 -->
          <data-relation :data="data.dbList"></data-relation>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import apis from '@/utils/apis';
import dataRelation from './topic_detail_data_relation.vue';

export default {
  components: {
    dataRelation,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: [Number, String],
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.selfVisible = val;
      },
    },
  },
  computed: {
    title() {
      return [this.$t('dms_topic_detail_drawer.Topicxin_xi'), this.data.topicCode].join(' - ');
    },
  },
  data() {
    return {
      selfVisible: false,
      data: {
        dbList: [],
      },
      dicMap: {},
      tabIndex: 0,
    };
  },
  methods: {
    visibleChange(val) {
      if (val) {
        this.$emit('update:visible', val);
      } else {
        this.selfVisible = false;
        setTimeout(() => {
          this.$emit('update:visible', val);
        }, 300);
      }
    },
    getDetail() {
      this.$getJSON(apis.TopicDetail, { topicId: this.id }).then((res) => {
        this.data = res.data;
      });
    },
    getDic() {
      this.getDictionary('iot_topic_class,iot_topic_func_class,iot_topic_type,cloud_common_state', (data) => {
        const map = {};
        map.iot_topic_class = this.$transformDicValue(data.iot_topic_class);
        map.iot_topic_func_class = this.$transformDicValue(data.iot_topic_func_class);
        map.iot_topic_type = this.$transformDicValue(data.iot_topic_type);
        map.cloud_common_state = this.$transformDicValue(data.cloud_common_state);
        this.dicMap = map;
      });
    },
    getDicName(dicCode, val) {
      if (this.dicMap[dicCode]) {
        return this.dicMap[dicCode][`${val}`];
      }
      return val;
    },
  },
  mounted() {
    this.getDic();
    this.getDetail();
    // fix：appendToBody属性无效
    document.body.appendChild(this.$el);
  },
};
</script>

<style lang="scss">
.topic-detail-drawer {
  .info-content {
    display: flex;
    height: 100%;

    .base-msg {
      width: 280px;
      height: 100%;
      background: #f8f9fb;
      padding: 0 24px;
      flex-shrink: 0;

      .title {
        color: #495057;
        font-size: 14px;
        font-weight: bold;
        line-height: 60px;
      }

      .msg-list {
        margin-top: 1px;
        .msg-item {
          border-bottom: 1px solid #eef2f7;
          .desc {
            color: #98a6ad;
            font-size: 12px;
            line-height: 17px;
            margin-top: 8px;
            max-height: 200px;
            overflow-y: auto;
          }
        }
        .msg-item-content {
          overflow: hidden;
          font-size: 12px;
          color: #6c757d;
          line-height: 18px;
          padding: 8px 0;
          .key {
            float: left;
          }
          .val {
            float: right;
            max-width: 60%;
            overflow: hidden;
            word-break: break-all;
          }
        }
      }
    }

    .table-content {
      padding: 24px;
      flex: 1;
      overflow-x: auto;
      display: flex;
      flex-direction: column;

      .tab-content {
        overflow-x: auto;
        width: 100%;
        flex: 1;
      }
    }
  }
}
</style>
